import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad5KBlue5GRed = () => <CrossRoad coords="1461.000000, 645.000000"/>;

export default CrossRoad5KBlue5GRed;